import gql from 'graphql-tag'

// 获得acordForms
export const getRelatedAcordForms = gql`
  query($masterType: HistoryMasterType!,$masterId: Int!) {
    getRelatedAcordForms(
      masterType: $masterType
      masterId: $masterId
    ) {
        id
        name
      } 
  }
`
